var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8,21c-1.7,0-3-1.4-3-3.1c0-0.5,0.1-1.1,0.4-1.5h-5c0.3,0.5,0.4,1,0.4,1.5c0,1.7-1.4,3.1-3,3.1c-1.7,0-3-1.4-3-3.1 c0-0.8,0.3-1.6,0.9-2.2c-0.3-0.3-0.5-0.7-0.6-1.1L2.9,4.4H2.2C1,4.4,0,3.4,0,2.2S1,0,2.2,0h2.6c0.8,0,1.5,0.5,1.9,1.1h13.9 c0.8,0,1.5,0.4,2,1c0.5,0.6,0.6,1.4,0.4,2.2L21,11.2c-0.2,0.6-0.5,1-1,1.4c0.5,0.4,0.8,1,0.8,1.7c0,0.7-0.3,1.3-0.8,1.7 c0.5,0.5,0.8,1.3,0.8,2C20.8,19.6,19.5,21,17.8,21z M8.5,15.1h8.4l0.3,1.3c-0.6,0.3-1,0.9-1,1.6c0,0.9,0.8,1.7,1.7,1.7 c0.9,0,1.7-0.8,1.7-1.7c0-0.7-0.4-1.3-1-1.6l0.2-1.3c0.5,0,0.8-0.4,0.8-0.9c0-0.5-0.4-0.9-0.9-0.9H7.7l-0.3-1.7h11.2 c0.5,0,1-0.3,1.1-0.8l1.9-6.9c0.1-0.3,0-0.7-0.2-1c-0.2-0.3-0.6-0.5-0.9-0.5H5.7L5.6,2C5.5,1.6,5.1,1.3,4.7,1.3H2.2 c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9H4l2.1,11.3c0.1,0.3,0.3,0.6,0.7,0.7l1.6,0.3L8.5,15.1z M8.4,15.8l-1.4,0.6 c-0.7,0.3-1.1,0.9-1.1,1.6c0,0.9,0.8,1.7,1.7,1.7s1.7-0.8,1.7-1.7c0-0.7-0.4-1.3-1-1.6L8.4,15.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping_cart.5b12ae7963196f67bd4dc79c8e7782b0.svg";
export { ForwardRef as ReactComponent };